import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {MotionPathPlugin} from "gsap/MotionPathPlugin";

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('home-banner')) {
        ScrollTrigger.create({
            trigger: "#home-banner",
            start: "bottom top",

            onLeave: () => {
                document.querySelector('header').classList.add('active');
            },
            onEnterBack: () => {
                document.querySelector('header').classList.remove('active');
            }
        });
    }
});